import React from "react";

const Field = (props) => {

  return (
    <div
      className="form-group"
      data-testid={props.id}
    >
      <label htmlFor={props.id} className="form-label col-xs-12">
        { props.label }
        <span className="required">*</span>
      </label>
      <div
        className="col-xs-12 survey-field"
      >
        { props.children }
      </div>
      <p className="help-block col-xs-12">{ props.error }</p>
    </div>
  );
};


const Input = (props) => {
  return (
    <Field {...props}>
      { props.options.map(({ answer, resource_uri }, index) => (
        <div
          key={index}
          className="survey-input-container"
        >
          <input
            id={resource_uri}
            name={props.type === "radio" ? props.id: resource_uri}
            type={props.type}
            role={props.type}
            value={answer}
            onChange={props.onChange}
            data-question-id={props.id}
          />
          <label
            htmlFor={resource_uri}
          >{ answer }</label>

        </div>
      ))
      }

    </Field>
  );
};


const toComponent = (question, onChange) => {
  const props = {
    id: question.resource_uri,
    label: question.question,
    options: question.answers,
    onChange: onChange,
    type: question.input_type === "multi" ? "checkbox" : "radio",
  };

  return (
    <React.Fragment>
      <Input {...props } />
      <hr/>
    </React.Fragment>
  );
};

export {
  toComponent,
};
